<template>
  <div style="height: 530px; overflow: auto;">
    <app-filter :filter-list="table_filter" @search="search">
      <template #custom="{ form_key, form_item }">
        <!-- 以词拓词 - 种子词集合 -->
        <div v-if="form_key === 'query_word'">
          <el-input
            v-model="form_item.temp_value"
            style="width: 400px"
            maxlength="20"
            show-word-limit
            placeholder="输入文本按回车添加，限10个关键词，每个关键词不超过20个字"
            @keyup.enter.native="handleEnter(form_item)"
          />
          <div v-if="form_item.value.length" class="mt-5">
            <el-tag
              v-for="(item, i) in form_item.value"
              :key="i"
              class="mr-5 mt-5"
              closable
              :disable-transitions="true"
              @close="handleClose(form_item, i)"
            >{{ item }}</el-tag>
          </div>
        </div>
      </template>
    </app-filter>
    <app-table
      ref="app-table"
      :table-key="table_key"
      :get-data="getKeywordList"
      :check="true"
      check-key="word"
      :is-row-click="true"
      :is-reserve-checked="false"
      :is-request="false"
      :is-current-page="false"
      :table-props="{ height: '400px' }"
      :table-on="{ 'sort-change': onSortChange }"
      @select-tr="onSelectionChange"
    />
    <div class="flex justify-between align-center mt-10">
      <div>
        <div>关键词推荐总数：{{ total_num }}</div>
        <div>已选中关键词数：{{ multiple_selection.length }}</div>
      </div>
      <div>
        <el-button
          type="primary"
          @click="handleAddKeywords"
        >
          添加关键词
          <i class="el-icon-caret-right" />
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getBusinessPointListApi } from '@/api/tool/business-point';
import { getKeywordListApi } from '@/api/tool/keyword';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

/** 产品要求：固定拓词版位集 */
const site_sets = ['SITE_SET_QBSEARCH', 'SITE_SET_WECHAT_SEARCH'];

export default {
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
    'BarChart': () => import('./components/BarChart.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    advertiserId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      table_filter: require('./model/table-filter.js')(this),
      table_key: require('./model/table-key.js')(this),
      table_params: {},
      multiple_selection: [],
      total_num: 0,
    };
  },
  created() {
    this.getBusinessPointList();
  },
  methods: {
    /**
     * 搜索
     * @param {Object} params 过滤参数
     */
    search(params) {
      this.table_params = params;
      this.$refs['app-table'].seekTable();
    },
    /** 获取行业业务点信息 */
    getBusinessPointList() {
      return new Promise((resolve, reject) => {
        const form_context = this.local_sharing_data.getFormContext();
        const { dataController } = form_context.config;
        const channel_interface = dataController.getChannelInterfaceEnum();
        const advertiser_id = dataController.getRequestAdvertiser();
        getBusinessPointListApi({
          channel_interface,
          advertiser_id,
          filtering: {
            site_sets,
          },
        }).then(({ list = [] }) => {
          // 仅需【游戏】部分的数据
          const game_list = (list.find(({ value }) => value === 10)?.options || []).map(item => Object.assign(item, { disabled: true }));
          const removeEmptyChildren = (trees = [], children = 'options') => {
            return trees.map(tree => {
              if (tree[children]?.length) {
                tree[children] = removeEmptyChildren(tree[children]);
              } else {
                delete tree[children];
              }
              return tree;
            });
          };
          const { business_point_id } = this.table_filter;
          business_point_id.options = removeEmptyChildren(game_list, 'options');
          resolve(game_list);
        }).catch(reject);
      });
    },
    /** 获取关键词列表 */
    getKeywordList() {
      return new Promise((resolve, reject) => {
        const form_context = this.local_sharing_data.getFormContext();
        const { dataController } = form_context.config;
        const channel_interface = dataController.getChannelInterfaceEnum();
        const advertiser_id = dataController.getRequestAdvertiser();
        const { recommend_category, query_word, business_point_id, order_by } = this.table_params;
        const params = {
          channel_interface,
          advertiser_id,
          filtering: {
            site_sets,
            system_industry_id: 21474836523,
            ...(recommend_category && { recommend_category }),
            ...(query_word && { query_word }),
            ...(business_point_id && { business_point_id }),
            ...(order_by && { order_by }),
          },
        };
        getKeywordListApi(params).then(res => {
          const result = res?.list || [];
          this.total_num = result.length;
          this.multiple_selection.splice(0);
          resolve(result);
        }).catch(reject);
      });
    },
    /** 多选 */
    onSelectionChange(val) {
      this.multiple_selection = val;
    },
    /** 推荐类别change事件 */
    recommendCategoryChange(value) {
      const { query_word, business_point_id } = this.table_filter;
      const is_word = value === 'RECOMMEND_BY_WORD';
      query_word.hidden = !is_word;
      business_point_id.hidden = is_word;
    },
    /** 种子词回车事件 */
    handleEnter(form_item) {
      if (!form_item.temp_value) {
        this.$message.warning('请输入关键词！');
        return;
      }
      if (form_item.value.length >= 20) {
        this.$message.warning('关键词限制20个！');
        return;
      }
      if (form_item.value.includes(form_item.temp_value)) {
        this.$message.warning('已存在该关键词！');
        return;
      }
      form_item.value.push(form_item.temp_value);
      form_item.temp_value = '';
    },
    /**
     * 标签移除事件
     * @param {Object} form_item 表单配置项
     * @param {number} index 标签索引
     */
    handleClose(form_item, index) {
      form_item.value.splice(index, 1);
    },
    /** 添加关键词事件 */
    handleAddKeywords() {
      this.$emit('confirm', this.multiple_selection);
    },
    /** 排序 */
    onSortChange({ prop, order }) {
      this.table_params.order_by = [{
        sort_field: prop,
        sort_type: '',
      }];
      if (order === 'descending') {
        this.table_params.order_by[0].sort_type = 'DESCENDING';
      } else if (order === 'ascending') {
        this.table_params.order_by[0].sort_type = 'ASCENDING';
      } else {
        delete this.table_params.order_by;
      }
      this.$refs['app-table'].seekTable();
    },
  },
};
</script>
